{
  "message": "german",
  "mytext": "Auf Wiedersehen",
  "Colon": ":",
  "SeeMore": "Mehr lesen >",
  "Notification": "neu",
  "ProfileTitle": "Mein Profil",
  "NextButton": "Weiter",
  "PrintButton": "Drucken",
  "PreviousButton": "Zurück",
  "Reset": "Zurücksetzen",

  "Yes": "Ja",
  "No": "Nein",

  "Default Title": "Title",
  "Default Subtitle": "Subtitle",

  "And": "und",
  "Or": "oder",

  "Search": "Suche",
  "SearchResults": "Suchergebnisse",

  "Error": "Fehler",

  "Send": "Senden",
  "Refresh": "Aktualisieren",

  "Confirmation": "Achtung",

  "Profile": {
    "Title": "Mein Profil",
    "Username": "Benutzername",
    "Email": "E-Mail",
    "Role": "Rolle",
    "Confirmed": "Bestätigt",
    "CreationDate": "Erstellungsdatum"
  },

  "Status": {
    "new": "neu",
    "accepted": "Akzeptiert",
    "ready": "Bereit",
    "proposed": "Vorgeschlagen",
    "scheduled": "Geplant",
    "completed": "Abgeschlossen"
  },

  "Disclaimer": {
    "Title": "Disclaimer",
    "TextShort": "B. Braun Medical AG übernimmt ausserdem keine Gewährleistung oder Garantie im Hinblick auf die Richtigkeit, Vollständigkeit und Aktualität der Daten auf „pharmacists.bbraun.ch“.",
    "Text": "<p><b>Nutzungsbedingungen</b> Die auf der Website «pharmacists.bbraun.ch» enthaltenen Informationen, Angaben und Daten zu Produkten der B. Braun Medical AG, insbesondere zu Infusionslösungen und deren Anwendung, dienen ausschliesslich und allein zur Information von Spitalapothekern von Schweizer Spitälern, welche diese Arzneimittel in ihrem Spital einsetzen. Der Zugang zu diesen Informationen, Angaben und Daten wird Spitalapothekern gewährt, welche sich zum Zweck des Zugriffs auf diese Informationen vorgängig mit ihren persönlichen Daten registriert und nach Prüfung der Angaben durch den Betreiber ein Passwort für den Zugriff auf die Inhalte der Website erhalten haben. Mit dem Zugriff auf die Website erklärt der Nutzer sein Einverständnis mit den Nutzungsbedingungen und dem nachfolgenden Haftungsausschluss. <br/><b>Haftungsausschluss</b> Die B. Braun Medical AG hat die auf der Website zur Verfügung gestellten Informationen, Angaben und Daten mit der gebotenen Sorgfalt erarbeitet, übernimmt aber keine Gewähr für die jederzeitige Aktualität, Korrektheit, Vollständigkeit oder Qualität der bereitgestellten Informationen, Angaben und Daten. Die B. Braun Medical AG schliesst für sich und für die beteiligten Mitarbeitenden, soweit rechtlich zulässig, jegliche Haftung für Schäden jeglicher Art, für Personen- oder Sachschäden, für direkte oder indirekte Schäden, welche aus dem oder im Zusammenhang mit dem Zugriff auf die Informationen, der Nutzung der bereitgestellten Informationen oder dem Abfragen der Informationen entstehen können, aus. Der Haftungsausschluss umfasst ebenso die Haftung für den störungsfreien Betrieb der Website, insbesondere aufgrund technischer Mängel und die Haftung für  Schäden, die aus Übermittlungsfehlern, technischen Mängeln, Störungen oder Unterbrechungen des Internetzugangs, rechtswidrigen Eingriffen in Telekommunikationseinrichtungen, Einschmuggeln von Viren, Kopieren und Verfälschen von Inhalten, Netzüberlastungen, Nichterkennen von Fälschungen, Legitimationsmängeln, mutwilliger oder zufälliger Blockierung elektronischer Zugänge durch Dritte entstehen. Der Haftungsausschluss umfasst ebenso die Haftung für Schäden, die dem Nutzer (bzw. Kunden) aus der Nichterfüllung vertraglicher Verpflichtungen entstehen, sowie für indirekte Schäden und für Folgeschäden, wie entgangener Gewinn oder Ansprüche Dritter. Die B. Braun Medical AG behält sich vor, alle zur Verfügung gestellten Informationen oder Teile davon, jederzeit zu verändern, namentlich auch an technische oder rechtliche Entwicklungen anzupassen, zu ergänzen, zu löschen oder die Veröffentlichung zeitweise oder endgültig einzustellen.<br/> <b>Anwendbares Recht/Gerichtsstand</b> Die gesamte Website, die Nutzungsbedingungen und der Haftungsausschluss unterliegen ausschliesslich schweizerischem Recht. Sämtliche Streitigkeiten bezüglich dieser Bedingungen unterliegen der Gerichtsbarkeit der zuständigen Gerichte am Sitz der B. Braun Medical AG. </p>"
  },

  "Infusion": {
    "InContainer": {
      "Title": "Im Behältnis",
      "Text": "Infusionslösung wird nach Zusatz des Arzneimittels zum Behältnis auf die physikalisch-chemische Kompatibilität geprüft.",
      "MoreText": "Ringerfundin® wurde nach Zusatz folgender i.v. Arzneimittel auf physikalisch-chemische Kompatibilität über 24 Stunden bei Raumtemperatur geprüft."
    },
    "InLine": {
      "Title": "In Leitung",
      "Text": "Mischungen der Infusionslösung mit Arzneimittel werden im Verhältnis ihrer Infusionsgeschwindigkeiten in der Leitung auf die physikalisch-chemische Kompatibilität geprüft.",
      "MoreText":"Mischungen der Infusionslösung X® mit folgenden i.v. Arzneimitteln wurden im Verhältnis ihrer Infusionsgeschwindigkeiten auf die physikalisch-chemische Kompatibilität direkt nach Durchmischen (4 Minuten) und nach 60 Minuten Kontaktzeit geprüft:"
    }
  },

  "Requests": {
    "TestPlan": "Prüfplan",
    "CreationDate": "Erstellungsdatum",
    "EditedDate": "Bearbeitungsdatum",
    "SendQuestion": "Frage senden",
    "SendResponse": "Antwort senden",
    "FileRejectedForGivenReason": "Datei abgelehnt aufgrund:",
    "FileNotFound": "Datei nicht gefunden",
    "SendPrufplan": "Prüfplan senden",
    "PrufplanSent": "Prüfplan wurde gesendet",
    "SelectPrufplan": "Prüfplan auswählen",
    "NewDocument": "Neues Dokument",
    "InputPlaceholder": "Frage hier eingeben",
    "RejectRequest": "Anfrage ablehnen",
    "CreatePlan": "Plan erstellen",
    "CreatePlans": "Pläne erstellen",
    "ChooseMeds": "Medikamente auswählen",
    "ChooseMedsSubtitle": "Wählen Sie aus, für welche der folgenden Medikamente Sie einen Testplan erstellen möchten (für jedes ausgewählte Medikament wird ein zugehöriger Test erstellt)",
    "Questions": "Abklärung / Fragen Ecotox",
    "AutomatedAnswer": "Automatische Antwort",
    "ClickToSeePdf": "Klicken Sie hier, um das PDF zu sehen",
    "TestPlanPropositionDocument": "Prüfplan vorschlag (PDF)",
    "ProjectNumber": "Projektnummer",
    "Revision": "Revision",
    "Revisions": "Revisionen",
    "Status": "Status",
    "TestedPreparation": "Getestete Zubereitung",
    "Preparation": "Zubereitung",
    "DrugSolutionConcentration": "Arzneistoffkonzentration",
    "PerfusionRate": "Infusionsgeschwindigkeit",
    "Combination": "Kombination",
    "PreparationCompatibility": "Zubereitungskompatibilität",
    "NoRequestAtThisStep": "Keine Anfrage in diesem Schritt",
    "OtherTabsRequests": "Anfragen in anderen Schritt",
    "SelectedFile": "Ausgewählte Datei",
    "SaveDraft": "Entwurf speichern",
    "Saved": "Gespeichert",
    "AddCompatibility": "Kompatibilität hinzufügen",
    "SendTestReport": "Testbericht senden",
    "UploadTestReport": "Testbericht hochladen",
    "ChooseFile": "Datei auswählen",
    "DocumentName": "Dokumentname",
    "DocumentSize": "Dokumentgrösse",
    "DateVersion": "Datum / Version",
    "PublicationDate": "Veröffentlichungsdatum",
    "PublishCompatibility": "Kompatibilität veröffentlichen",
    "ValidatePlan": "Wenn Sie auf \"Ja\" klicken, akzeptieren Sie den vorgeschlagenen Plan.",
    "ThisActionCannotBeUndone": "Diese Aktion kann nicht rückgängig gemacht werden."
  },

  "Header": {
    "FirstNavBar": {
      "HomeButton": "Home",
      "LogoutButton": "Logout",
      "ContactButton": "Kontakt"
    },
    "SecondNavBar": {
      "ProdukteUndTherapienButton": "Produkte und Therapien",
      "StoriesButton": "Stories",
      "Companies": "Unternehmen",
      "SearchPlaceholder": "Suche"
    }
  },
  "Footer": {
    "FooterNav": {
      "LegalNotice": "Impressum",
      "TermsOfUse": "Nutzungsbedingungen",
      "Privacy": "Datenschutz",
      "GeneralTerms": "Allgemeine Geschäftsbedingungen"
    }
  },
  "Home": {
    "Title": "Pharmacist",
    "Subtitle": "Wissensportal",
    "ShowButton": "Anzeigen",
    "CompatibilityData": {
      "Title": "Kompatibilitätsdaten",
      "Description": "Die hier aufgeführten Kompatibilitäten beziehen sich auf die physikalisch-chemische Kompatibilität wie pH-Verschiebung, Farbveränderung, Trübung, Partikelgrössenveränderung oder Ausfällung. Die Daten geben keine Auskunft betreffend Pharmakokinetik und -dynamik. Die aufgeführten Mischungen stellen keine Dosier-Empfehlungen dar."
    },
    "OsmolarityCalculator": {
      "Title": "Osmolaritäten-Rechner",
      "Description": "Der Osmolaritäten-Rechner macht es Ihnen einfach, die Osmolarität einer Lösung mit Zusätzen selbst zu berechnen."
    },
    "ProductInformation": {
      "Title": "Produktinformationen",
      "Description": "B. Braun bietet Produkte und Lösungen für Infusion."
    },
    "FAQ": {
      "Title": "FAQ",
      "Description": "Hier finden Sie eine Zusammenstellung der wichtigsten Fragen und Antworten zu verschiedenen Themen im Zusammenhang mit der Infusionstherapie und Parenteraler Ernährung."
    },
    "News": {
      "Title": "News",
      "NoNews": "Keine News verfügbar"
    }
  },
  "Faq": {
    "Title": "FAQ's",
    "Subtitle": "Frequently Asked Questions",
    "Help":"Wie können wir Ihnen helfen?"
  },
  "Login": {
    "PresentationSection": {
      "Title": "Informationen für Spitalapotheker",
      "Resume": "Mit der Website «pharmacists.bbraun.ch» stellt Ihnen B. Braun Medical AG ein für Sie als Spitalapotheker exklusives Wissensportal zur Verfügung."
    },
    "LoginSection": {
      "Title": "Login",
      "P1": "Die Webseite “pharmacists.bbraun.ch” stellt folgenden Informationsumfang zur Verfügung:",
      "P2": "Aktuelle physikalisch-chemische Kompatibilitätsdaten unserer Produkte",
      "P3": "Osmolaritäten-Rechner zur Berechnung der Osmolarität von Infusionslösungen mit Zugabe von Infusionslösungszusätzen",
      "P4": "FAQ mit Antworten zu häufig gestellten Fragen zur Infusionstherapie",
      "DataPrivacyCheckbox": "Hiermit bestätige ich, dass ich die %LINK% zur Kenntnis genommen habe.",
      "DataPrivacyLink": "Datenschutzerklärung",
      "EmailUsername":"E-Mail Adresse/Benutzername",
      "Password":"Passwort",
      "RepeatPassword":"Passwort wiederholen",
      "ForgotPassword":"Passwort vergessen",
      "RegisterNow":"Jetzt anmelden",
      "ToRegister":"Registrieren",
      "ConfirmationSent":"Eine Bestätigungsmail wurde an Ihre E-Mail Adresse gesendet.",
      "AlreadyRegistered":"Sie sind bereits registriert?",
      "OldPassword":"Altes Passwort",
      "NewPassword":"Neues Passwort",
      "ConfirmNewPassword":"Neues Passwort wiederholen",
      "ResetPassword":"Passwort zurücksetzen"
    },
    "ErrorHandling": {
      "EmptyFields":"Bitte füllen Sie alle Felder aus.",
      "InvalidCredentials":"Falsche E-Mail Adresse oder Passwort.",
      "PasswordRegexp":"Das Passwort muss mindestens 8 Zeichen enthalten, einen Großbuchstaben, einen Kleinbuchstaben, eine Zahl und ein Sonderzeichen.",
      "PasswordMismatch":"Die Passwörter stimmen nicht überein.",
      "EmailRegexp":"Bitte geben Sie eine gültige E-Mail Adresse ein.",
      "EmailAlreadyRegistered":"Diese E-Mail Adresse ist bereits registriert.",
      "DataPrivacy": "Bitte bestätigen Sie, dass Sie die Datenschutzerklärung gelesen haben.",
      "UnknownError":"Ein unbekannter Fehler ist aufgetreten."
    },
    "DisclaimerSection": {
      "Title": "Disclaimer",
      "DisclaimerShort": "B. Braun Medical AG übernimmt keine Garantie oder Gewährleistung bezüglich des Inhalts der Website.",
      "DisclaimerMore": " Unter keinen Umständen haften die B. Braun Medical AG, ihre Mitarbeitenden, Händler, Lieferanten oder Auftragsnehmer für Schäden jeglicher Art, einschliesslich, aber nicht beschränkt auf Schadenersatzansprüche, zufällige, direkte, indirekte, besondere, verschuldensabhängige oder Folgeschäden, Nutzungsausfälle, Datenverluste, entgangene Einkünfte oder Gewinne, Verluste oder Beschädigungen von Eigentum, Ansprüche Dritter oder sonstige Verluste jeglicher Art."
    }
  },
  "News": {
    "Introduction": "Unter der Rubrik News informieren wir Sie über neue Daten zu chemisch-physikalischen Kompatibilitätsuntersuchungen. Des Weiteren erfahren Sie hier Neuigkeiten zu unseren Infusionslösungen und Pharmaprodukten sowie unseren Spüllösungen."
  },
  "ProductCatalog": {
    "Title": "Produktinformationen",
    "PresentationSection": {
      "Title": "Produkt Katalog",
      "Resume": "B. Braun bietet Produkte und Lösungen für Infusion."
    },
    "Informations": {
      "Title": "Produktinformationen",
      "Subtitle1": "Die wesentlichen Produktinformationen wie Dosierung & Anwendung sind der Fachinformation auf ",
      "Subtitle2": " zu entnehmen.",
      "Documentation": "Unterlagen, Informationsmaterial",
      "Brochures": {
        "Title": "Ablage der verschiedenen Broschüren",
        "Products": "Produktübersicht",
        "Concept": "Infusionskonzept"
      }
    }
  },
  "ProductDetails": {
    "FAQs": "Produkt FAQs",
    "Dosage": "Dosierung/Anwendung",
    "Documents": "Zugehörige Dokumente",
    "Articles": "Artikeln",
    "Article": {
      "Description": "Beschreibung",
      "Reference": "Artikelnummer",
      "Pharmacode": "Pharmacode",
      "Quantity": "Verkaufseinheit",
      "QuantityUnit": "Stück"
    }
  },
  "Compatibility": {
    "Title":"Kompatibilitätsdaten",
    "Drug": "Arzneimittel",
    "DisplayBy": "Anzeige von",
    "DrugSelection": "Arzneimittelauswahl",
    "TestedMixture": "geprüfte Mischungen",
    "NotTested": "nicht getestet",
    "Compatible": "kompatibel",
    "Incompatible": "nicht kompatibel",
    "IncompatibleShort": "n. kompatibel",
    "Explanation": "Die Angaben zum Mischungsverhältnis werden hier wie folgt angegeben: 1+1 steht für eine Mischung aus 1 Teil Trägerlösung plus 1 Teil Arzneistofflösung (es läuft z.B. 1 mL/Minute Ringerfundin zusammen mit 1 mL/Minute Aequifusin oder auch 2 mL/Minute Ringerfundin zusammen mit 2 mL/Minute Calcium Braun 10%, das zuvor 1:11 verdünnt wurde). Eine Verdünnung 1:11 steht für 1 Teil aufgefüllt auf insgesamt 11 Teile, z.B.: 1 mL Calcium Braun 10% ad 11 mL aufgefüllt mit NaCl 0,9%.",
    "ShowAllCompatibilitiesButton":"Alle Kompatibilitäten anzeigen",
    "ShowCompatibilitiesButton":"Kompatibilitäten anzeigen",
    "NoneSelectedError":"Es wurden keine Kompatibilitäten ausgewählt.",
    "From": "von",
    "To": "bis",
    "mlperminute": "ml/Minute",
    "ml": "ml",

    "Introduction": {
      "Title": "Einleitung",
      "IntroductionParagraph1": "Die hier aufgeführten Kompatibilitäten beziehen sich auf die physikalisch-chemische Kompatibilität wie pH-Verschiebung, Farbveränderung, Trübung, Partikelgrössenveränderung oder Ausfällung.",
      "IntroductionParagraph2": "Die Daten geben keine Auskunft betreffend Pharmakokinetik und -dynamik. Die aufgeführten Mischungen stellen keine Dosier-Empfehlungen dar."
    },
    "CarrierSolutions":{
      "Title":"Trägerlösungen"
    },
    "DrugAddition":{
      "Title":"Arzneimittelzugabe"
    },
    "SelectDrug":{
      "Title":"Arzneimittel auswählen",
      "TradeNameButton":"Handelsname",
      "ActiveIngredientButton":"Wirkstoff",
      "AllButton":"Alle",
      "SelectedMedicinalProducts":"AUSGEWÄHLTE ARZNEIMITTEL"
    },
    "PhysicoChemicalCompatibility":{
      "Title":"Physikalisch-chemische Kompatibilität",
      "Concentration": "Wirkstoffkonzentration",
      "SolutionConcentration": "Wirkstoffkonzentration in der Arzneimittellösung",
      "MedSolution": "Arzneimittellösung",
      "MedSolutionConcentration": "Konzentration Arzneimittellösung",
      "Volume": "Volumen Trägerlösung",
      "InContainerParagraph": "Physikalisch-chemische Kompatibilität von der Lösung und Arzneimittel im Behältnis.",
      "InLineParagraph": "Physikalisch-chemische Kompatibilität von der Lösung und Arzneimittel in der Leitung (Y-Stück)",

      "CarrierSolution":"Trägerlösung",
      "DrugAdditive":"Arzneimittel / Zusatz",
      "DrugAdditiveTab":{
        "TradeNameAddition":"Handelsname",
        "ActiveIngredient":"Wirkstoff",
        "MixingRatio":"Effektive geprüfte Wirkstoffkonzentration in der Mischung",
        "TestedIntervals":"Geprüfte infusionsraten",
        "TestedMix": "Geprüfte Mischungen",
        "Compatibility":"Kompatibilität",
        "Direct":"direkt",
        "DirectDetails":"4 min Kontaktzeit",
        "Indirect60":"60 min Kontaktzeit",
        "Indirect24":"24 Std. Kontaktzeit",
        "After":"nach",
        "Details":"Details",
        "OpenDetails":"Details anzeigen",
        "CloseDetails":"Details aufrufen",
        "CombinationEvaluation":"Kombinationsbewertung"
      },
      "Results": {
        "MixDetails": "Details zur geprüften Mischung",
        "Concentration": "Zubereitung der Arzneimittellösung",
        "QuantityFor500": "Zugesetze Menge zu Trägerlösung",
        "Comments": "Bemerkungen",
        "PossibleResults": "Individuelle Einstellungen",
        "TransportSolutionConcentration": "Konzentration Trägerlösung",
        "SolutionConcentration": "Konzentration Arzneimittel",
        "DirectCompat": "Direkte Kompatibilität",
        "AfterCompat": "Nach 24 Std. Kompatibilität"
      },

      "LeitungSlider1": "Infusionsgeschwindigkeit der Trägerlösung (ml / Minute)",
      "LeitungSlider2": "Konzentration Wirkstoff nach Verdünnen/Rekonstitution",
      "LeitungSlider3": "Infusionsgeschwindigkeit der zubereiteten Arzneistofflösung (ml / Minute)",

      "BehaltnisSlider1": "Wirkstoffkonzentration in der zugesetzten Arzneimittelzubereitung (mg / ml)",
      "BehaltnisSlider2": "Volumen Arzneimittelzubereitung (ml)"
    },
    "CompatibilityRequest":{
      "Title":"Kompatibilitätsanfrage",
      "PresentationSection": {
        "Title": "Anfrage zur physikalisch-chemischen Kompatibilitätsuntersuchung",
        "Resume": "Bei einem häufig eingesetzten noch nicht getesteten Arzneimittel veranlassen wir für Sie nach Rücksprache eine Kompatibilitätsuntersuchung. Verwenden Sie hierzu das Formular und Sie erhalten von uns eine Offerte."
      },
      "NewRequest": "Arzneimittel nicht gefunden? Neue Prüfung anfragen !",
      "Editor": "Editor",
      "LabTester": "Labor prüfer",

      "CarrierSolution":"Trägerlösung",
      "DrugAdditive":"Arzneimittel / Zusatz",
      "DrugAdditiveSubText":"Geben Sie hier Ihren Bedarf an",
      "FirstName":"Vorname",
      "LastName":"Nachname",
      "SpitalInstitution": "Spital / Institution",
      "Street":"Straße",
      "PLZ":"PLZ",
      "Location":"Ort",
      "Country":"Land",
      "PositionOrFunction":"Position oder Funktion",
      "EmailAddress":"E-Mail Adresse",
      "Comment":"Bemerkung",
      "ApplicationDetails": "Details zur Applikation",
      "EmptyMedsList": "Bitte füllen Sie mindestens ein Medikament aus",
      "Created": "Ihre Anfrage wurde erfolgreich übermittelt. Sie werden in Kürze von B. Braun kontaktiert.",
      "Wizard": {
        "NewRequest": "Neu Anfrage",
        "Clarification": "Abklärung",
        "AcceptPlan": "Prüfplan freigeben",
        "TestPlan": "Phase Prüfplan",
        "AcceptResults": "Anfrage freigeben",
        "Request": "Anfrage",
        "Requester": "Anfrager",
        "Date": "Datum"
      }
    }
  },
  "Osmolarity": {
    "Title": "Osmolaritäten-Rechner",
    "Subtitle": "Infusionslösungen",
    "Osmolarity": "Osmolarität",
    "Volume": "Volume",
    "Additives": {
      "Title": "Infusionzusätze"
    },
    "Solutions": {
      "Title": "Infusionlösung"
    },
    "Free": {
      "Title": "Freie Eingabe",
      "Name": "Name:",
      "Osmolarity": "Osmolarität:",
      "Volume": "Volumen:",
      "Description": "Wählen Sie ein Volumen und eine Osmolarität"
    },

    "Introduction": {
      "Title": "Einleitung",
      "P1": "Berechnen Sie die Osmolarität einer Infusionslösung mit einem oder mehreren Infusionszusätzen.",
      "P2": "Bei Verabreichung einer Lösung über 800 mosm/l ist eine zentralvenöse Verabreichung vorteilhaft, um das Risiko von Phlebitiden zu minimieren. In der Pädiatrie sollte erwogen werden, eine Infusionslösung mit einer Osmolarität über 500 mosm/l zentralvenös zu verabreichen.",
      "P3": "Mit dem Osmolaritätenrechner erfolgt einerseits keine Überprüfung der therapeutischen Plausibilität (keine Dosier- und keine Anwendungsempfehlung) anderseits keine Überprüfung der chemisch-physikalischen Kompatibilität der Inhaltsstoffe."
    },
    "SelectInfusionSolution":{
      "Title":"Infusionslösung auswählen"
    },
    "EnterTheInfusionSolutionVolume":{
      "Title":"Infusionslösung Volumen eingeben"
    },
    "SelectInfusionAdditives":{
      "Title":"Infusionzusätze auswählen"
    },
    "EnterVolumeForInfusionAdditives":{
      "Title":"Infusionzusätze Volumen eingeben"
    },
    "Result":{
      "Title":"Ergebnis",
      "InfusionSolution":"Infusionslösung",
      "InfusionAdditives":"Infusionzusätze",
      "TotalVolume":"Gesamtvolumen der Mischung (ml)",
      "OsmolarityOfTheMixture":"Osmolarität der Mischung (mosm/l)",
      "Warning": {
        "below500": "Peripher- und zentralvenöse Verabreichung möglich",
        "between500And800": "Zentralvenöse Verabreichung in Erwägung ziehen",
        "above800": "Zentralvenöse Verabreichung empfohlen"
      },
      "Ingredients":"Inhaltsstoffe",
      "Absolutely":"Absolut*",
      "Relative":"Relativ**",
      "AbsolutelyDescription":"*Absolut: Angaben beziehen sich auf Ihre gewählte Gesamtlösung",
      "RelativeDescription":"**Relativ: Angaben beziehen sich auf einen Liter",
      "AdditionalInfo":"Ausführliche Informationen sind der publizierten Arzneimittelinformation zu entnehmen (siehe Packungsbeilage oder www.swissmedicinfo.ch)"
    }
  },
  "SearchPage": {
    "Items": {
      "Any": "Artikel",
      "All": "alle",
      "For": "für",
      "Found": "gefunden",
      "Products": "Nur Produkte",
      "News": "Nur News",
      "FAQ": "Nur FAQ"
    },
    "Types": {
      "product": "Produkt",
      "news": "News",
      "faq": "FAQ"
    },
    "Research": "Suche:",
    "More": "Mehr dazu"
  },
  "Requester": {
    "RejectionReason": "Grund für die Ablehnung",
    "Close": "Schließen",
    "Send": "Senden"
  },
  "Privacy": {
    "Title": "Datenschutz"
  }
}
